
import {
  defineComponent,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  ref,
  watch,
} from "vue";
import { Loading, Dialog, Toast } from "vant";
import { parseImgUrl } from "@/utils";

export default defineComponent({
  props: {
    isShowLeaveDailog: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    VanLoading: Loading,
    [Dialog.Component.name]: Dialog.Component,
  },
  setup(props, contx) {
    const proxyData = reactive({
      parseImgUrl: parseImgUrl,
      isShowLeaveDailog: props.isShowLeaveDailog,
      leaveDetail: {
        // img: parseImgUrl("ipdImages", "icon-handshake.svg"),
        textObj: [
          {
            text: "已为您取消当前的预约时间",
            status: "ok",
          },
          {
            text: "系统将自动调整设备状态",
            status: "ok",
          },
          {
            text: "感谢您的预约使用",
            status: "ok",
          },
        ],
      },
      closeDailog() {
        contx.emit("closeDailog");
      },
    });
    watch(
      props,
      (newProps: any) => {
        proxyData.isShowLeaveDailog = newProps.isShowLeaveDailog;
      },
      {
        deep: false,
        immediate: true,
      }
    );
    onMounted(() => {});
    return {
      ...toRefs(proxyData),
    };
  },
});
